import TradingTagsSchema from "./trading-tags.schema.json"

export default {
	'trading-tags': TradingTagsSchema
}